<template>
  <div class="list">
    <div class="tab_tab">
      <div class="top_right" style="display: flex;align-items: center;gap: 10px;width: 100%;">
        <!-- <i class="el-icon-s-order"></i>我的检测报告 -->

        <el-date-picker
          v-model="date"
          @change="datechose"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- <span style="color: #aaadb5;"
          >您提交的检测或校对论文一般将于48小时之内生成报告&emsp;&emsp;</span
        > -->
        <div style="width: calc(100% - 380px);color: #aaadb5;display: inline-block;display: flex;align-items: center;" 
          ><EllipsisTooltip content="您提交的论文检测/校对申请，报告通常在48小时内生成" /></div
        >
      </div>
      <div class="tab_top">
        <!-- <div
          class="tab_css"
          @click="active_is = 1"
          :class="active_is == 1 ? 'active_css' : ''"
        >
          查重结果
        </div>
        <div
          class="tab_css"
          @click="active_is = 2"
          :class="active_is == 2 ? 'active_css' : ''"
        >
          校对结果
        </div> -->
      </div>
    </div>
    <div class="table_css__">
      <!-- :data="active_is == 1 ? checkList : proofreadList" -->
      <el-table
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        ref="multipleTable"
        :data="proofreadList"
        tooltip-effect="dark"
        :header-cell-style="{ fontSize: '14px', color: '#606266' }"
        :row-class-name="tableRowClassName"
        :cell-style="getCellStyle"
        :cell-class-name="getCellClassName"
       
      >
        <el-table-column label="文章标题" align="left" min-width="350px">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; gap: 10px">
              <img
                v-if="scope.row.is_read == 1 && scope.row.status == 3"
                src="../../../assets/imgs/2.2/Ellipse.png"
                alt=""
              />

              <div class="read_no_css" v-else></div>
              <div class="tit_css" style="width: calc(100% - 30px)">
                <img
                  v-if="scope.row.file_type == 'txt'"
                  class="imgType_up"
                  mode="widthFix"
                  src="https://xcx.newacademic.net/video/icon/txt.png"
                />
                <img
                  v-if="
                    scope.row.file_type == 'doc' ||
                    scope.row.file_type == 'docx'
                  "
                  class="imgType_up"
                  mode="widthFix"
                  src="https://xcx.newacademic.net/video/icon/word.png"
                />
                <img
                  v-if="
                    scope.row.file_type == 'xls' ||
                    scope.row.file_type == 'xlsx'
                  "
                  class="imgType_up"
                  mode="widthFix"
                  src="https://xcx.newacademic.net/video/icon/xls.png"
                />
                <img
                  v-if="
                    scope.row.file_type == 'ppt' ||
                    scope.row.file_type == 'pptx'
                  "
                  class="imgType_up"
                  mode="widthFix"
                  src="https://xcx.newacademic.net/video/icon/ppt.png"
                />
                <img
                  v-if="scope.row.file_type == 'pdf'"
                  class="imgType_up"
                  mode="widthFix"
                  src="https://xcx.newacademic.net/video/icon/pdf.png"
                />
                <EllipsisTooltip :content="scope.row.title" />
                <!-- {{ scope.row.title }} -->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="大小" align="left" min-width="120px">
          <template slot-scope="scope"> {{ scope.row.task_type }}</template>
        </el-table-column>
        <el-table-column label="类型" align="left" min-width="100px">
          <template slot-scope="scope"> {{ scope.row.task_type }}</template>
        </el-table-column>
        <el-table-column label="上传时间" align="left" min-width="160px">
          <template slot-scope="scope">
            {{
              scope.row.create_time | parseTime("{y}-{m}-{d} {h}:{i}")
            }}</template
          >
        </el-table-column>
        <el-table-column label="检测状态" align="left" min-width="120px">
          <template slot-scope="scope">
            <el-tag type="info" size="medium" v-if="scope.row.status == 0"
              >排队等待</el-tag
            >
            <el-tag size="medium" style="color: #409eff;border: 1px solid #d9ecff;background-color: #ecf5ff;" v-if="scope.row.status == 1">正在上传</el-tag>
            <el-tag size="medium" style="color: #409eff;border: 1px solid #d9ecff;background-color: #ecf5ff;" v-if="scope.row.status == 2">正在检测</el-tag>
            <el-tag size="medium" type="success" v-if="scope.row.status == 3"
              >检测完成</el-tag
            >
            <el-tag size="medium" type="danger" v-if="scope.row.status == 4"
              >处理失败</el-tag
            >
            <el-tag size="medium" type="danger" v-if="scope.row.status == 5"
              >任务过期</el-tag
            >
            <el-tag size="medium" type="danger" v-if="scope.row.status == 6"
              >已删除</el-tag
            ></template
          >
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="left" width="150px">
          <template slot-scope="scope">
            <div class="btn_s">
              <span
                class="btn_txt"
                v-if="scope.row.status == 3"
                @click="download(scope.row.task_id, scope.row.status)"
                >下载</span
              >
              <span class="btn_txt" @click="deletes(scope.row.task_id)"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div class="list_header">
      <div class="title">
        <h2 style="text-align: center; font-size: 25px">我的检测报告</h2>
      </div>
    </div> -->
    <!-- <div class="list_box">
      <div style="width: 100%">
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <div class="type">
              <span>{{ item.task_type }}</span>
            </div>
            <p>
              <span>检测状态： </span>
              <el-steps
                :active="item.status + 1"
                finish-status="success"
                simple
                style="margin-top: 20px"
              >
                <el-step title="排队等待"></el-step>
                <el-step title="上传成功"></el-step>

                <el-step title="正在检测"></el-step>
                <el-step
                  v-if="item.status !== 4 && item.status !== 5"
                  title="检测完成"
                ></el-step>
                <el-step
                  v-if="item.status == 4"
                  title="处理失败"
                  status="error"
                ></el-step
                ><el-step
                  v-if="item.status == 5"
                  title="任务过期"
                  status="error"
                ></el-step
              ></el-steps>
            </p>
            <p><span>论文标题：</span>{{ item.title }}</p>
            <p><span>作者：</span>{{ item.author }}</p>
            <p><span>文件类型：</span>{{ item.file_type }}</p>
            <p>
              <span>创建时间：</span
              >{{ item.create_time | parseTime("{y}-{m}-{d} {h}:{i}") }}
            </p>
            <div class="btn">
              <el-button
                type="primary"
                icon="el-icon-download"
                round
                @click="download(item.task_id, item.status)"
                >下载报告</el-button
              >
              <el-button
              type="danger"
              icon="el-icon-delete"
              round
              disabled
              @click="deletes(item.task_id)"
              >删除报告</el-button
            >
            </div>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
import EllipsisTooltip from "@/components/EllipsisTooltip.vue";
import { eventBus } from "../../../eventBus";
import {
  userAge,
  downloadable,
  deleteFile,
  extend_read,
} from "@/Api/checkAgain";
import {
  detail_list,
  input_file,
  download,
  get_limit,
  delete_detail,
} from "@/Api/scholarcy_writeful01";
export default {
  components: {
    EllipsisTooltip,
  },
  data() {
    return {
      active_is: 1,
      list: [
        // {
        //   create_time: "2022-01-11T14:12:59",
        //   task_type: "查重",
        //   title: "test_title",
        //   author: "yrq",
        //   file_type: "docx",
        //   status: 0,
        //   task_id:"8"
        // },
        // {
        //   create_time: "2022-01-11T14:13:56",
        //   task_type: "查重",
        //   title: "test_title",
        //   author: "yrq",
        //   file_type: "docx",
        //   status: 0,
        //   task_id:"8"
        // },
      ],
      date: [],
      //   actives: 5,
      currentDate: new Date(),
      checkList: [],
      proofreadList: [],
      //   animationShow: "",
      historyFileList: [],
      loading: false,
    };
  },
  created() {
    if (this.date.length == 0) {
      // let time = new Date(this.currentDate.getTime() - 31536000000);
      // let time1 = new Date(this.currentDate.getTime());
      // console.log(time1);
      // console.log(time);
      this.date = this.getCurrentAndPreviousDate();
      console.log(this.getCurrentAndPreviousDate());
    }
    this.reportList();
  },
  methods: {
    getCurrentAndPreviousDate() {
      const currentDate = new Date(); // 获取当前日期

      // 格式化当前日期
      const formattedCurrentDate = this.formatDate(currentDate);

      // 获取前一天的日期
      const previousDate = new Date(currentDate);
      previousDate.setDate(currentDate.getDate() - 6); // 设置为前一天

      // 格式化前一天日期
      const formattedPreviousDate = this.formatDate(previousDate);

      return [formattedPreviousDate, formattedCurrentDate];
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // formateDate (date, fmt) {
    //   if (/(y+)/.test(fmt)) {
    //     fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    //   }
    //   let o = {
    //     'M+': date.getMonth() + 1,
    //     'd+': date.getDate(),

    //   }
    //   for (let k in o) {
    //     if (new RegExp(`(${k})`).test(fmt)) {
    //       let str = o[k] + ''
    //       fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
    //     }
    //   }
    //   return fmt
    // },
    // 左边补0函数
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    //显示问题详情列表
    contentDetail(row) {
      // console.log(row);
    },
    mouseEnter() {
      this.animationShow = "paused";
    },
    datechose() {
      this.reportList();
    },
    // 查重与校对报告列表
    reportList() {
      // let time = this.formateDate(this.date[0],'yyyy-MM-dd') +' 00:00:00'
      // let time1 = this.formateDate(this.date[1],'yyyy-MM-dd') +' 23:59:59'
      let time = this.date[0] + " 00:00:00";
      let time1 = this.date[1] + " 23:59:59";
      userAge({
        year_start: time,
        year_end: time1,
      })
        .then((res) => {
          // console.log(res);
          this.list = res.data.data;
          this.checkList = [];
          this.proofreadList = [];

          this.list.forEach((item) => {
            if (item.task_type == "查重") {
              // this.checkList.push(item);
              this.proofreadList.push(item);
            }
            if (item.task_type == "校对") {
              item.create_time = item.create_time.replace(/T/g, " ");
              // console.log(item.create_time);
              this.proofreadList.push(item);
            }
          });
          //   console.log(this.list);
          // console.log(this.proofreadList);
          // this.proofreadList = [...this.proofreadList,...this.proofreadList,...this.proofreadList,...this.proofreadList,...this.proofreadList]
          let ids = {
            open_id: localStorage.getItem("code"),
            organ_name: localStorage.getItem("org_name"),
          };
          detail_list(ids)
            .then((res) => {
              // console.log(res);
              if (res.data.data) {
                this.historyFileList = res.data.data;
                this.historyFileList.forEach((item) => {
                  this.$set(item, "type", "Writeful");
                  this.proofreadList.push(item);
                });
              }

              // console.log(this.historyFileList);
              this.proofreadList = this.proofreadList.sort((a, b) => {
                let aTimeString = a.create_time;

                let bTimeString = b.create_time;
                aTimeString = aTimeString.replace(/-/g, "/");
                bTimeString = bTimeString.replace(/-/g, "/");
                let aTime = new Date(aTimeString).getTime();
                let bTime = new Date(bTimeString).getTime();

                return bTime - aTime;
              });
              // console.log(this.proofreadList);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下载报告
    download(id, status) {
      //   console.log(id);
      if (status == 3) {
        let downId = {
          task_id: id,
        };
        downloadable(downId)
          .then((res) => {
            // console.log(res);
            window.open(res.data.data);
            this.disposeRead(id);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "当前检测未完成！请在检测完成后下载！",
          type: "warning",
        });
      }
    },
    download_w(url) {
      window.open(url, "_blank");
    },
    // 删除报告
    deletes(id) {
      this.$confirm("确认删除该报告？")
        .then((_) => {
          // console.log(id);
          let del = {
            task_id: id,
          };
          deleteFile(del)
            .then((res) => {
              console.log(res);
              if (res.data.error_code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
              if (res.data.error_code == 0) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              }
              // this.reportList();
              //   console.log("删除成功");
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((_) => {});
    },
    disposeRead(id) {
      let del = {
        task_id: id,
      };
      extend_read(del)
        .then((res) => {
          console.log(res);
          eventBus.$emit("updateNum", 0);
          this.reportList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 删除报告
    deletes_w(id) {
      console.log("a");
      this.$confirm("确认删除该报告？")
        .then((_) => {
          // console.log(id);
          let del = {
            task_id: id,
          };
          delete_detail(del)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "warning",
                });
              }
              this.reportList();
              //   console.log("删除成功");
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((_) => {});
    },
    tableRowClassName({ row, rowIndex }) {
      return "";
    },
    getCellStyle({ row, column }) {
      return "";
    },
    getCellClassName({ row, column }) {
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  min-height: calc(100vh - 180px);
  // overflow-x: hidden;
  // overflow-y: scroll;
  min-width: 780px;
  //   background: white;
  //   padding: 10px 10%;
  .title {
    margin: 0px 0 20px 50px;
    color: #1f5bb6;
    font-size: 25px;
    // text-align: center;
    i {
      font-size: 25px;
      line-height: 28px;
    }
    span {
      margin-left: 20px;
      font-size: 16px;
      color: #737679;
    }
  }
  .checks {
    margin: 10px 20px;
    padding-top: 50px;
    background: white;
    padding: 20px 100px;
    min-height: calc(100vh - 790px);
    // display: flex;
    // justify-content: center;
    // align-items: center;
    h3 {
      font-size: 21px;
    }
    .not {
      width: 20%;
      margin: 0 40%;
    }
    .results {
      margin: 30px 0 0 70px;
      display: flex;
      flex-wrap: wrap;
      .ones {
        margin: 0px 30px 20px 30px;
        width: 130px;
        .one {
          //   -moz-box-shadow: 2px 2px 10px #0f0e0e;
          //   -webkit-box-shadow: 2px 2px 10px #1b1b1b;
          // box-shadow:2px 2px 10px #909090;
          box-shadow: 5px 5px 10px gray;
          border-radius: 10px;
          .image {
            width: 130px;
            height: 120px;
            background-image: url("../../../assets/imgs/图层 2 拷贝 3.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            // border-start-start-radius: 10px;
            // border-start-end-radius: 10px;
            img {
              width: 80%;
            }
            i {
              overflow: hidden;
              font-size: 21px;

              color: rgb(204, 204, 204);
              position: absolute;
              top: 0px;
              right: 0px;
              z-index: 1000;
              cursor: pointer;
              img {
                width: 21px;
                color: aqua;
              }
            }
            i:hover img {
              // width: 30px;
              transform: translateY(-50px);
              filter: drop-shadow(#f13e3e 0 50px);
            }
          }

          .status {
            .icon {
              height: 45px;
              display: inline-block;
              display: flex;
              justify-content: center;
              align-items: center;
              color: rgb(0, 204, 255);
              //   height: 30px;
              .texts {
                display: inline-block;
                cursor: pointer;
                //     height: 30px;
                //   line-height: 30px;
              }
              .down :hover {
                color: rgb(36, 197, 247) !important;
              }
            }
            // background: red;
            // border-end-start-radius: 50px;
            // border-end-end-radius: 10px;
          }
        }
        .names {
          p {
            margin: 10px 5px;
            line-height: 20px;
            // width: 130px;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            cursor: pointer;
          }
        }
      }
    }
  }
  .proof {
    margin: 30px 20px 10px 20px;
    min-height: calc(100vh - 775px);
    padding-top: 50px;
    background: white;
    padding: 20px 100px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    h3 {
      font-size: 21px;
    }
    .not {
      width: 20%;
      margin: 0 40%;
    }
    .results {
      margin: 30px 0 0 70px;
      display: flex;
      flex-wrap: wrap;
      .ones {
        margin: 0px 30px 20px 30px;
        width: 130px;
        .one {
          //   -moz-box-shadow: 2px 2px 10px #0f0e0e;
          //   -webkit-box-shadow: 2px 2px 10px #1b1b1b;
          // box-shadow:2px 2px 10px #909090;
          box-shadow: 5px 5px 10px gray;
          border-radius: 10px;
          .image {
            width: 130px;
            height: 120px;
            background-image: url("../../../assets/imgs/图层 2 拷贝 3.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            // border-start-start-radius: 10px;
            // border-start-end-radius: 10px;
            img {
              width: 80%;
            }
            i {
              overflow: hidden;
              font-size: 21px;

              color: rgb(204, 204, 204);
              position: absolute;
              top: 0px;
              right: 0px;
              z-index: 1000;
              cursor: pointer;
              img {
                width: 21px;
                color: aqua;
              }
            }
            i:hover img {
              // width: 30px;
              transform: translateY(-50px);
              filter: drop-shadow(#f13e3e 0 50px);
            }
            img {
              width: 80%;
            }
          }

          .status {
            .icon {
              height: 45px;
              display: inline-block;
              display: flex;
              justify-content: center;
              align-items: center;
              color: rgb(0, 204, 255);
              //   height: 30px;
              .texts {
                display: inline-block;
                cursor: pointer;
                //     height: 30px;
                //   line-height: 30px;
              }
              .down :hover {
                color: rgb(36, 197, 247) !important;
              }
            }
            // background: red;
            // border-end-start-radius: 50px;
            // border-end-end-radius: 10px;
          }
        }
        .names {
          p {
            // width: 130px;
            word-wrap: break-word;
            word-break: break-all;
            margin: 10px 5px;
            line-height: 20px;
            // font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
          }
        }
      }
    }
  }
}
.el-popover {
  p {
    margin: 10px 0;
    span {
    }
  }
}
.titles {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.logo_w {
  width: 30px;
  position: relative;
  top: 105px;
  left: 85px;
  z-index: 100;
}
.tab_tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  box-shadow: 0 -1px 0 0 #e4e4e6 inset;
  border-radius: 8px 8px 0 0;
  padding: 16px;
}
.tab_top {
  // min-width: 50%;
  display: flex;

  // flex-direction: column;
  // justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  .tab_css {
    display: flex;
    height: 34px;
    padding: 4px 24px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    background: #f1f2f2;
    cursor: pointer;
    font-size: 14px;
    color: #8d8f94;
    line-height: 22px;
  }
  .active_css {
    color: #fff;
    background: #e2426b;
  }
}
.btn_s {
  display: flex;
  align-items: center;
  gap: 18px;
}
.btn_txt {
  color: #e2426b;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
}
.read_no_css {
  width: 6px;
  height: 6px;
}
.table_css__ {
  min-height: calc(100vh - 195px);

  background: #fff;
  /deep/ .el-table__header {
    .el-table__cell {
      color: #666b75 !important;
      line-height: 22px;
      font-weight: 400;
    }
  }
  /deep/ .el-table__row {
    .el-table__cell {
      color: #16181b;
    }
  }
  /deep/ .el-table__body-wrapper {
    height: calc(100vh - 270px) !important;
  }
}
.tit_css {
  display: flex;

  align-items: center;
  gap: 12px;
  .imgType_up {
    width: 24px;
    height: 24px;
  }
}
</style>